var _path, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPepulLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 203,
    height: 247,
    viewBox: "0 0 203 247",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M195.843 209.02C173.198 227.779 134.805 239.496 105.322 241.16C65.9357 243.595 31.9275 231.251 1.16102 206.536C-1.16356 204.665 0.651745 201.83 3.409 203.216C36.983 219.952 66.7723 229.094 104.346 228.154C132.178 227.459 167.064 216.539 192.212 204.247C196.216 202.316 199.585 205.805 195.843 209.02Z",
    fill: "#018BF6"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_11_12)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M56.044 178.669L56.0347 178.678V18.6896C56.0347 16.9691 57.4312 15.4127 59.359 15.4127H116.258C146.202 15.4127 170.743 39.4916 170.743 68.5376C170.743 97.6204 146.165 122.656 116.508 122.656H80.3277H78.915V124.068V182.063C78.915 183.735 77.3167 185.34 75.5907 185.34H59.3683C57.4404 185.34 56.044 183.784 56.044 182.063V178.669ZM78.915 99.8937V101.306H80.3277H115.767C133.798 101.306 147.872 86.8163 147.872 68.3077C147.872 50.6937 133.708 37.2768 115.767 37.2768H80.3277H78.915V38.6895V99.8937Z",
    fill: "#018BF6",
    stroke: "#018BF6",
    strokeWidth: 2.82533
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_11_12",
    x: 37.9229,
    y: 0.0839939,
    width: 164.848,
    height: 220.067,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 6.958,
    dy: 9.74121
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 11.8286
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.18 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_11_12"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_11_12",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPepulLogo);
export default __webpack_public_path__ + "static/media/pepul_logo.a0c0e862e633c7c42f2708b3c2120fa2.svg";
export { ForwardRef as ReactComponent };